export function getStates(state) {
  return state.states.list;
}
